import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { dossiersApi } from "../api/client";

/**
 * Exercice sur lequel travaillent les écrans de tenue.
 *
 * Par défaut, le dernier exercice qui accepte encore la saisie ; à défaut, le
 * dernier ouvert. Le choix est propre à l'écran : changer d'exercice sur le
 * grand livre ne change pas celui de la saisie. Le défaut se déduit au rendu,
 * sans effet ni état intermédiaire : tant que rien n'est choisi, c'est lui.
 *
 * Un exercice [prefere] — celui d'une pièce vers laquelle on vient d'être
 * conduit — passe devant le défaut, jamais devant le choix de l'utilisateur.
 */
export function useExerciceCourant(dossier: string, prefere?: string) {
  const exercices = useQuery({
    queryKey: ["exercices", dossier],
    queryFn: () => dossiersApi.exercices(dossier),
  });
  const [choisi, setChoisi] = useState<string | null>(null);

  const liste = exercices.data;
  const parDefaut =
    liste == null
      ? undefined
      : ([...liste].reverse().find((exercice) => exercice.accepteLaSaisie) ?? liste[liste.length - 1]);
  const exercice = liste?.find((e) => e.id === choisi) ?? liste?.find((e) => e.id === prefere) ?? parDefaut;

  return {
    exercices: liste,
    chargement: exercices.isPending,
    erreur: exercices.error,
    exercice,
    choisir: setChoisi,
  };
}
